import { useState, useEffect } from 'react';
//redux
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  createDraft,
  deleteDraftById,
  getCurrentFilteredDrafts
} from '../../../features/state/StateDraft-slice';
import { getAgencyById, clearAgency } from '../../../features/state/StateAgency-slice';
import { getChapterById, clearChapter } from '../../../features/state/StateChapter-slice';
import { getTitleById, clearTitle } from '../../../features/state/StateTitle-slice';
// helpers
import { GenerateDraftColumnDefinition } from '../../../components/stateful/table/TableHelper';
import { Draft, GenerateBlankDraft } from '../../../utilities/interfaces/Draft';
import { useNotificationHelper } from '../../../utilities/helpers/NotificationHelper';
import { clearDraftNotes } from '../../../features/state/StateDraftNote-slice';
// import { ProposedRule } from '../../../utilities/interfaces/ProposedRule';


export const useCodeDraftingController = () => {
  // redux
  const values = useAppSelector((state) => state.draft.value);
  const fetchingValues = useAppSelector((state) => state.draft.fetchingValues);
  const chapter = useAppSelector((state) => state.chapters.chapter);
  const title = useAppSelector((state) => state.titles.selectedTitle);
  const agency = useAppSelector((state) => state.agency.agency);
  const currentFilteredDrafts = useAppSelector((state) => state.draft.currentFilteredDrafts);

  // state
  const [selectedDraft, setSelectedDraft] = useState<any>({});
  const dispatch = useAppDispatch();
  const [viewDrafts, setViewDrafts] = useState<boolean>(true);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [columnData, setColumnData] = useState<any>([])
  const [draft, setDraft] = useState<Draft>();
  // const [chapterData, setChapterData] = useState<any>();


  const { addNotification } = useNotificationHelper();

  useEffect(() => {
    if (currentFilteredDrafts.length < 1) {
      dispatch(getCurrentFilteredDrafts())
    }

    if (columnData.length < 1) {
      generateColumnData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {}, [currentFilteredDrafts]);

  const generateColumnData = async () => {
    let columnDef = GenerateBlankDraft();
    let columns = await GenerateDraftColumnDefinition(columnDef);
    setColumnData(columns);
  }

  const openDraft = (event: any, draft: any) => {
    setSelectedDraft(draft);
    toggleView()
  }

  const toggleView = () => {
    viewDrafts ? setViewDrafts(false) : setViewDrafts(true);
    dispatch(clearDraftNotes());
  }

  const toggleModal = () => {
    openModal ? setOpenModal(false) : setOpenModal(true);
  }

  const getDraftDetails = async (data: Draft) => {
    // dispatch(getAgencyById(data.agencyId))
    dispatch(clearChapter())
    dispatch(clearTitle());
    dispatch(clearAgency());
    dispatch(getChapterById(data.chapterId))
    dispatch(getTitleById(data.titleId))
    dispatch(getAgencyById(data.agencyId));
  }

  const createNewDraft = (newChapter: boolean) => {
    // if chapterData exists the user is creating a new Chapter so chapterId on the draft will be null
    // this should create a new proposed rule record with the newly created chapter details included
    if (!draft) {
      addNotification({
        type: 'error',
        message: `No draft data found`
      })
    }
    else if (!draft.chapterId && !newChapter) {
      addNotification({
        type:'error',
        message: 'Must select chapter or create new chapter on draft creation.'
      })
    }
    else if (draft) {
      delete draft.id;
      dispatch(createDraft(draft)).unwrap()
        .then(() => {
          postDraftApiRequest(`${draft.draftName} was saved successfully`)
          toggleModal();
        })
        .catch((error: any) => {
          addNotification({
            type: 'error',
            message: `${draft.draftName} was unable to save. ${error.message}`,
          });
        });
    }
  }

  const updateDraft = (draft: any, chapterData: any) => {
    setDraft(draft)
    // setChapterData(chapterData);
  }

  const deleteDraft = (id: number) => {
    dispatch(deleteDraftById(id)).then( () =>
        postDraftApiRequest(`Draft was deleted successfully`))
        .catch((error: any) => {
          addNotification({
            type: 'error',
            message: `Draft was not deleted. ${error.message}`,
          })});
  }

  const postDraftApiRequest = (message: string) => {
    dispatch(getCurrentFilteredDrafts());
    addNotification({
      type: 'success',
      message: message,
    });
  }


  return {
    // state
    selectedDraft,
    viewDrafts,
    columnData,
    openModal,
    // redux
    values,
    fetchingValues,
    agency,
    title,
    chapter,
    currentFilteredDrafts,
    // functions
    generateColumnData,
    openDraft,
    toggleView,
    toggleModal,
    getDraftDetails,
    createNewDraft,
    updateDraft,
    deleteDraft,
  };
};
